import React from "react"
import DocumentTitle from 'react-document-title';
import Icon from "@material-ui/core/Icon";
import FormControl from "../../../node_modules/@material-ui/core/FormControl/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import * as Connections from "../../utils/Connections.js";
import Button from '@material-ui/core/Button';
import {FarmerInfoDialog, ExpendatureDialog } from "../../components";


class Voucher extends React.Component {
    constructor(props) {
        super(props)

        this.state = {

            allOrders: [],
            filteredOrders: [],
            allFarmers: [],
            allVouchers: [],
            allExpenses: [],
            allVouchersExpenditure:[],
            allExpensesExpenditure: [],
            allFarmerVouchers: false,
            active: "",
            filteredVouchers: [],
            searchName: "",
            fullProfile: false,
            farmerImages: [],
            farmerProfile: [],
            produceFarming: [],
            farmerId: null,
            openExpenditure: false
        }


        this.handleError = this.handleError.bind(this)
        this.successGetVouchers = this.successGetVouchers.bind(this)
        this.getFarmerImage = this.getFarmerImage.bind(this)
        this.filterFarmers = this.filterFarmers.bind(this)
        this.handleCancelDialog = this.handleCancelDialog.bind(this)
        this.fullProfileRequest = this.fullProfileRequest.bind(this)
        this.allFarmerVouchers = this.allFarmerVouchers.bind(this)
        this.successGetFarmerVouchers = this.successGetFarmerVouchers.bind(this)
    }

    fullProfileRequest(farmerId, farmer) {
        let images = [];
        farmer.images.forEach(function (image) {
            images.push(image.link)
        })
        this.setState({
            farmerId: farmerId,
            fullProfile: true,
            farmerProfile: farmer,
            produceFarming: farmer.produce_farming,
            farmerImages: images
        })
    }

    handleError(data) {
        alert(data)
    }

    componentDidMount() {
        var data1 = {
            "type": "getAllVouchersExpenditure"
        }
        Connections.performSecureRequest(data1, this.successGetVouchers, this.handleError)

    }

    handleCancelDialog(dialogName) {
        this.setState({
            [dialogName]: false,
            farmerId: null,
            amount: 0
        })
    }

    successGetVouchers(data1) {
        this.setState({
            allVouchers: data1,
            filteredVouchers: data1
        })
    }

    successGetFarmerVouchers(data) {
        this.setState({
            allVouchersExpenditure: data.expenditure,
            allExpensesExpenditure: data.expenditure,
            openExpenditure: true
        })
    }

    allFarmerVouchers(farmerId, farmer) {
        let self = this
        this.setState({
            farmerId: farmerId,
            allFarmerVouchers: true,
            farmerProfile: farmer
        }, function () {
            let data = {
                type: "getAllFundingExpenditurePerFarmer",
                farmerId: farmerId
            }
            Connections.performSecureRequest(data, self.successGetFarmerVouchers, self.handleError)
        })
    }

    getFarmerImage(imageName) {
        return Connections.getProfileImageLink() + imageName
    }

    filterFarmers() {
        let toUse = this.state.allVouchers
        let self = this
        if (this.state.active !== "") {
            toUse = toUse.filter(function (voucher) {
                return voucher.voucher.state.toLowerCase().includes(self.state.active.toLowerCase())
            })
        }
        if (this.state.searchName !== "") {
            toUse = toUse.filter(function (voucher) {
                return (
                    voucher.voucher.farmerDetails.name.toLowerCase().includes(self.state.searchName.toLowerCase()) ||
                    voucher.voucher.farmerDetails.surname.toLowerCase().includes(self.state.searchName.toLowerCase()) ||
                    voucher.voucher.farmerDetails.phone.toLowerCase().includes(self.state.searchName.toLowerCase()) ||
                    voucher.voucher.farmerDetails.email.toLowerCase().includes(self.state.searchName.toLowerCase()) ||
                    voucher.voucher.farmerDetails.username.toLowerCase().includes(self.state.searchName.toLowerCase()) ||
                    voucher.voucher.farmerDetails.farmName.toLowerCase().includes(self.state.searchName.toLowerCase())
                )
            })
        }


        this.setState({
            filteredVouchers: toUse
        })

    }


    handleFilterChange(attr, value) {
        let self = this
        this.setState({
            [attr]: value
        }, function () {
            self.filterFarmers()
        })

    }

    render() {
        return (
            <div>
                <DocumentTitle title="Khula - Home">
                    <div className="main-content">

                        <div className="row">

                            <div className="headervouchers">


                                <div className="input-group col-sm-3 col-xs-3 col-lg-3 col-md-3"
                                     style={{verticalAlign: "middle", paddingTop: "1rem", paddingLeft: "1rem"}}>
                                    <input type="text" className="form-control" placeholder="Search"
                                           value={this.state.searchName}
                                           onChange={(e) => this.handleFilterChange("searchName", e.target.value)}/>
                                </div>

                                <div className="col-xs-9 col-sm-9 col-md-9 col-lg-9 col-xl-9">

                                    <FormControl style={{marginRight: "1rem", width: "10rem", verticalAlign: "middle"}}>
                                        <InputLabel htmlFor="age-simple"
                                                    style={{fontSize: "15px", fontWeight: "normal"}}>Active/Not
                                            Active</InputLabel>
                                        <Select
                                            value={this.state.active}
                                            onChange={(e) => this.handleFilterChange("active", e.target.value)}
                                            // value={values.age}
                                            // onChange={handleChange}
                                            // inputProps={{
                                            //     name: 'age',
                                            //     id: 'age-simple',
                                            // }}
                                        >
                                            <MenuItem value="">All</MenuItem>
                                            <MenuItem value="1">Active</MenuItem>
                                            <MenuItem value="0">Not Active</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>

                            <div style={{marginTop: "2rem"}}>
                                {this.state.filteredVouchers.map((voucher,i) =>
                                    <div key={i} className="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"
                                         style={{padding: "1rem"}}>
                                        <div style={{
                                            border: "1px solid grey",
                                            padding: "1rem",
                                            backgroundColor: "white"
                                        }}>

                                            <h6><img alt="farmer" className="voucherFarmersImg" style={{float: "right"}}
                                                     src={this.getFarmerImage(voucher.voucher.farmerDetails.image_name)}/>Farmer: {voucher.voucher.farmerDetails.name + " " + voucher.voucher.farmerDetails.surname}
                                            </h6>
                                            <p>{voucher.voucher.id} : <b>{voucher.voucher.state === 1 ? "active" : "not active"}</b>
                                            </p>
                                            <p>Total Voucher Value: {voucher.voucher.assignedAmount}</p>
                                            <p>Remaining Balance: {voucher.voucher.value}</p>


                                            <Button disabled={voucher.voucher.state === 1} variant="outlined"
                                                    color="primary"
                                                    style={{
                                                        fontSize: "12px",
                                                        width: "49%",
                                                        marginRight: "0.3rem",
                                                        color: "green",
                                                        borderColor: "green",
                                                        disabled: true,
                                                        backgroundColor: voucher.voucher.state === 0 ? "white" : "#a39f93"
                                                    }}>Pay | <img alt="absa"
                                                style={{width: 20, height: 20, marginLeft: 5}}
                                                src="/images/wallet-absa.png" className="fa-upload"/></Button>
                                            <Button
                                                onClick={() => this.fullProfileRequest(voucher.voucher.farmerDetails.id, voucher.voucher.farmerDetails)}
                                                variant="outlined" color="primary" style={{
                                                fontSize: "12px",
                                                width: "49%",
                                                color: "green",
                                                borderColor: "green"
                                            }}>See Farm | <Icon className="fa-upload">more_horiz</Icon></Button>


                                            <Button disabled={voucher.voucher.state === 0} variant="outlined"
                                                    color="primary"
                                                    style={{
                                                        fontSize: "12px",
                                                        width: "100%",
                                                        color: "green",
                                                        borderColor: "green",
                                                        marginTop: "0.3rem",
                                                        backgroundColor: voucher.voucher.state === 0 ? "#a39f93" : "white"
                                                    }}
                                                    onClick={() => this.allFarmerVouchers(voucher.voucher.farmerDetails.id, voucher.voucher.farmerDetails)}>Track
                                                Expenses | <Icon
                                                    className="fa-upload">more_horiz</Icon></Button>
                                        </div>
                                    </div>
                                )}

                            </div>

                        </div>
                        <FarmerInfoDialog
                            open={this.state.fullProfile}
                            handleCancelDialog={(item) => this.handleCancelDialog(item)}
                            farmerImages={this.state.farmerImages}
                            farmerProfile={this.state.farmerProfile}
                            produceFarming={this.state.produceFarming}
                            farmerId={this.state.farmerId}
                            // fundFarmerRequest={(id)=>this.fundFarmerRequest(id)}

                        />
                        <ExpendatureDialog
                            dialogOpen={this.state.openExpenditure}
                            farmerProfile={this.state.farmerProfile}
                            vouchers={this.state.allVouchersExpenditure}
                            onCancel={()=>this.handleCancelDialog("openExpenditure")}
                        />
                    </div>
                </DocumentTitle>
            </div>


        )

    }

}

export default Voucher;


// WEBPACK FOOTER //
// ./src/pages/HomePageBabies/Voucher.js